<template>
  <b-overlay :show="showOverlay" class="b-overlay-liste" rounded="sm">
    <div class="liste-sollicitations container">
      <div class="row">
        <div class="col-10 m-0 pr-0">
          <b-form @submit="preventDefault">
            <b-form-input id="input-1" ref="recherche" v-model="motRecherche"
              placeholder="N°Récla/Locataire/Commune ..." type="search" v-on:keydown.enter.prevent="preventDefault" />
          </b-form>
        </div>
        <div class="col-2 p-0 pt-1 m-0">
          <b-button :class="[showGeolocated ? 'btn-info' : 'btn-secondary','btn btn-sm rounded-circle',]"
            v-model="showGeolocated" :pressed.sync="showGeolocated">
            <i :class="[showGeolocated ? 'fa-map-marker-alt' : 'fa-map-marker', 'fas', ]"></i>
          </b-button>
        </div>
      </div>
      <div class="row">
        <p class="col-12 d-inline text-muted small"> Vous pouvez chercher une sollicitation. </p>
      </div>
      <div class="row">
        <div class="col-12 info-nb-sollicitations">
          <div class="bg-primary p-1 rounded d-flex align-items-center justify-content-center text-white">
            <span class="me-1">{{ nbSollicitations }} sollicitations</span>
            <span v-if="source == 'relance'" class="me-1"> avec {{ relanceToShow }} {{ relanceToShow > 1 ? 'relances' :
              'relance' }}</span>
            <span v-else class="me-1"> depuis {{ dateDeb }}</span>
            <span v-if="showGeolocated"> dans les {{ rangeDist }} km</span>
            <button type="button" class="btn btn-secondary btn-sm ml-2" variant="primary" v-if="dateDebutIsBeforeNow"
              @click="loadOneLessYear"><i class="fas fa-sort-amount-up"></i></button>
            <button type="button" class="btn btn-secondary btn-sm ml-2" variant="primary" @click="loadOneMoreYear"><i
                class="fas fa-sort-amount-down"></i></button>
          </div>
        </div>
      </div>
      <div class="row" v-show="showGeolocated">
        <div class="my-auto offset-1 col-2 p-0">
          <i class="fas fa-map-marked-alt"></i>{{ rangeDist }}km
        </div>
        <b-form-input class=" col-7" id="rangeDistance" v-model="rangeDist" name="rangeDistance" type="range"
          :min="minRange" :max="maxRange" :step="step"></b-form-input>
      </div>
      <div class="row" v-if="manageRelance">
        <div class="my-auto offset-1 col-2 p-0">
          <i class="fas fa-sync-alt"></i>
          {{ relanceToShow }}
        </div>
        <b-form-input class="col-7 my-0" id="relanceLvl" v-model="relanceToShow" name="Relance" type="range" min="1"
          :max="relanceMaxRange"></b-form-input>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <toggle-button v-if="source == 'liste' && showAffectedToggle" v-model="showAffected" :font-size="15" :ref="showAffectedToggle"
            :height="30" :labels="{
              unchecked: 'Mes sollicitations créées',
              checked: 'Mes sollicitations affectées',
            }" :width="250" />
          <br v-if="source == 'liste'" />
          <div class="mb-2">
            <b-button-group>
              <b-button v-model="showEnCours" :pressed.sync="showEnCours" class="enCours">
                En cours
                <b-spinner small label="Small Spinner" v-show='notClosedIsLoading'></b-spinner>
              </b-button>
              <b-button v-model="showEnAttente" :pressed.sync="showEnAttente" class="enAttente">
                En attente
                <b-spinner small label="Small Spinner" v-show='notClosedIsLoading'></b-spinner>
              </b-button>
              <b-button v-model="showClotures" :pressed.sync="showClotures" class="clotures">
                Cloturés
                <b-spinner small label="Small Spinner" v-show='closedIsLoading'></b-spinner>
              </b-button>
            </b-button-group>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-12 p-0">
          <ul class="list-group list-group-flush">
            <li v-for="sollicitation in page" :key="sollicitation.id" class="list-group-item flex sol"
              @click="setSelectedSollicitationAndRedirectToFicheSuivi(sollicitation.id)">
              <div class="sollicitation-img">
                <i :class="fontawesomeico(sollicitation.type)"></i> <br />
                {{ sollicitation.type }}
              </div>
              <div class="sollicitation-infos row align-items-center mx-0 p-1 g-0">
                <div class="col-7 p-0 text-center">
                  <span>{{ timeStampToDate(sollicitation.debut) }}</span>
                </div>
                <div class="col-5 p-0 text-right">
                  <b-badge pill variant="secondary">{{ sollicitation.id }}</b-badge>
                </div>
                <div class="col-12 p-0">
                  <span v-if="sollicitation.etage != null && sollicitation.etage != '*'" class="d-inline">
                    Etage {{ sollicitation.etage }}
                  </span>
                  <span v-if="
                      sollicitation.etage != null &&
                      sollicitation.etage != '*' &&
                      ((sollicitation.entree != null &&
                        sollicitation.libelleAdresse) ||
                        sollicitation.libelleProg != '')
                    " class="d-inline">
                    |
                  </span>
                  <span v-if="sollicitation.entree != null && sollicitation.libelleAdresse" class="d-inline">
                    {{ sollicitation.libelleAdresse }}
                  </span>
                  <span v-if="sollicitation.entree == null" class="d-inline">
                    {{ sollicitation.libelleProg }}
                  </span>
                </div>
                <div class="col-12 p-0 small text-muted" v-if="sollicitation.responsableLibelle">
                  Géré par {{ sollicitation.responsableLibelle }}
                </div>
                <div class="col-2">
                  <strong v-show="sollicitation.relance > 0" :style="'color:' + renderRelance(sollicitation.relance)">
                    <i class="fas fa-sync-alt"></i>{{ sollicitation.relance }}
                  </strong>
                  <small v-show="sollicitation.dist && showGeolocated">{{ sollicitation.dist }}Km</small>
                </div>
                <!--                      <br> "{{sollicitation.description}}"-->
              </div>
              <div class="sollicitation-etat">
                <span v-if="['A', 'N'].includes(sollicitation.etat)"
                  class="etat-absolute-position badge bg-warning text-warning border border-warning"></span>
                <span v-else-if="sollicitation.etat == 'O'"
                  class="etat-absolute-position badge bg-success border-success text-success"></span>
                <span v-else class="etat-absolute-position badge bg-black text-secondary border border-black"></span>
              </div>
              <p class="font-italic mb-0 position-absolute" style="font-size: 10px; right: 2px; bottom: 2px">
                {{ sollicitation.provenance | capitalize }} -
                {{ sollicitation.libelleReclamant }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="maxPage > 1" class="row align-items-center mt-2 p-2 position-sticky bottom-0"
        style="background-color: rgba(255, 255, 255, 0.8)">
        <div class="col-4 justify-content-center align-middle px-0">
          <div class="btn-group" role="group">
            <button v-if="currentPage > 2" class="btn btn-primary mb-0 ml-0" type="button" @click="currentPage = 1">
              <i class="fas fa-fast-backward align-middle"></i>
            </button>
            <button v-if="currentPage > 10" class="btn btn-primary mb-0 ml-0" type="button"
              @click="currentPage = currentPage - 10">
              <i class="fas fa-step-backward align-middle"></i>
            </button>
            <button v-if="currentPage > 1" class="btn btn-primary mb-0 ml-0" type="button" @click="currentPage--">
              <i class="fas fa-lg fa-caret-left align-middle"></i>
            </button>
          </div>
        </div>
        <div class="col-4 justify-content-center align-middle">
          <p class="align-middle my-0 font-weight-bold">
            {{ currentPage }} / {{ maxPage }}
          </p>
        </div>
        <div class="col-4 justify-content-center align-middle px-0">
          <div class="btn-group" role="group">
            <button v-if="currentPage < maxPage && maxPage > 1" class="btn btn-primary mb-0 mr-0" type="button"
              @click="currentPage++">
              <i class="fas fa-lg fa-caret-right align-middle"></i>
            </button>
            <button v-if="currentPage < maxPage - 10 && maxPage > 10" class="btn btn-primary mb-0 mr-0" type="button"
              @click="currentPage = currentPage + 10">
              <i class="fas fa-step-forward align-middle"></i>
            </button>
            <button v-if="currentPage < maxPage && maxPage > 2" class="btn btn-primary mb-0 mr-0" type="button"
              @click="currentPage = maxPage">
              <i class="fas fa-fast-forward align-middle"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import timeStampToDate from "@/js/timestampTranslation";
import regexNormalize from "@/js/regex";
import toast from "@/js/toast";
import lodash from "lodash";
import distance from "@/js/geolocationTool";

export default {
  name: "liste",
  data() {
    return {
      //Toggle
      showEnCours: null,
      showEnAttente: null,
      showClotures: null,
      showAffected: null,
      showGeolocated: null,
      motRecherche: "",

      //Savoir si on regarde notre listing ou notre patrimoine
      source: null,

      //Sollicitations chargées
      affectedSollicitations: null,
      createdSollicitations: null,
      patrimoineSollicitations: null,

      //Pagination
      currentPage: 1,
      maxItemPerPage: 10,
      relanceToShow: 2,

      latitude: 0,
      longitude: 0,
      rangeDist: 5,
      minRange: 1,
      maxRange: 30,
      step: 2,
      relanceMaxRange: 5,
      dateDebut: this.$store.getters['user/getDateDeb']
    };
  },
  watch: {
    $route: async function () {
      let path = this.$router.currentRoute.path;
      this.source = path.substring(path.lastIndexOf("/") + 1);
      this.showEnCours = true;
      this.showEnAttente = true;
      this.showClotures = false;
      this.showAffected = true;
      this.showGeolocated = false;
      this.motRecherche = "";
      this.currentPage = 1;
      this.maxItemPerPage = 10;
      this.relance = 2;
      this.reloadConfigUser();
      await this.loadData();
    },
    

    motRecherche(newVal) {
      let newConfig = this.userConfig??{};
      newConfig.motRecherche = newVal;
      this.$store.dispatch('user/setConfig', newConfig);
    },

    showGeolocated(newVal) {
      let newConfig = this.userConfig??{};
      newConfig.geoloc = newVal;
      this.$store.dispatch('user/setConfig', newConfig);
    },

    showAffected(newVal) {
      let newConfig = this.userConfig??{};
      newConfig.showAffected = newVal;
      this.$store.dispatch('user/setConfig', newConfig);
    },

    showEnCours(newVal) {
      let newConfig = this.userConfig??{};
      newConfig.showEnCours = newVal;
      this.$store.dispatch('user/setConfig', newConfig);
    },

    showEnAttente(newVal) {
      let newConfig = this.userConfig??{};
      newConfig.showEnAttente = newVal;
      this.$store.dispatch('user/setConfig', newConfig);
    },

    showClotures(newVal) {
      let newConfig = this.userConfig??{};
      newConfig.showClotures = newVal;
      this.$store.dispatch('user/setConfig', newConfig);
    },

    rangeDist(newVal) {
      let newConfig = this.userConfig??{};
      newConfig.rangeDist = newVal;
      this.$store.dispatch('user/setConfig', newConfig);
    },

    relanceToShow(newVal) {
      let newConfig = this.userConfig??{};
      newConfig.relanceToShow = newVal;
      this.$store.dispatch('user/setConfig', newConfig);
    },
  },
  created() {
    let path = this.$router.currentRoute.path;
    this.source = path.substring(path.lastIndexOf("/") + 1);
    this.reloadConfigUser();
  },
  methods: {
    preventDefault(e) {
      e.preventDefault();
    },
    getGeolocalisation() {
      //Tente de définir les coordonnées GPS de l'utilisateur
      if (this.showGeolocated) {
        navigator.geolocation.getCurrentPosition(
            (pos) => {
              this.longitude = pos.coords.longitude;
              this.latitude = pos.coords.latitude;
            },
            (err) => {
              this.longitude = 0;
              this.latitude = 0;
              toast.showToast(
                  "error",
                  "Erreur de géolocalisation: " + err.message
              );
            }
        );
      } else {
        this.longitude = 0;
        this.latitude = 0;
      }
      // Retourne vrai si des coordonnées sont positionnées, faux sinon
      return this.longitude != 0 && this.latitude != 0;
    },
    async loadOneMoreYear() {
      let nbYear = 1;
      this.dateDebut -= 31536000 * nbYear;
      this.$store.dispatch('sollicitations/clearSollicitations')
      await this.loadData();
    },
    async loadOneLessYear() {
      let nbYear = 1;
      this.dateDebut += 31536000 * nbYear;
      this.$store.dispatch('sollicitations/clearSollicitations')
      await this.loadData();
    },
    async loadData() {
      console.log("loadData called with source:", this.source);
      switch (this.source) {
        case "liste":
          await this.$store.dispatch('sollicitations/loadCreatedSollicitation', {
              tiersReclamant: this.codeTiers,
              pecReclamant: this.codePec,
              debutgt: this.dateDebut
          });
          if (this.showAffectedToggle) {
            await this.$store.dispatch('sollicitations/loadAffectedSollicitation', {
                pec: this.codePec,
                debutgt: this.dateDebut
            });
          }
          break;
        case "relance":
          await this.$store.dispatch('sollicitations/loadSollicitationsWithRelance')
          break;
        case "all":
          await this.$store.dispatch('sollicitations/loadAllSollicitation', {
              debutgt: this.dateDebut
          })
          break;
        default:
          await this.$store.dispatch('sollicitations/loadSollicitationsPatrimoineFromAPI', this.dateDebut);
      }
      this.$store.dispatch('sollicitations/setSelectedSollicitation', null)

    },
    timeStampToDate(timestamp) {
      // return new Date(timestamp * 1000).toLocaleDateString();
      return timeStampToDate(timestamp);
    },
    setSelectedSollicitationAndRedirectToFicheSuivi(sollicitationID) {
      this.$store.dispatch('sollicitations/setSelectedSollicitation', sollicitationID)
      this.$router.push({name: "fichesuivi", params: {id: sollicitationID}});
    },
    fontawesomeico(ID) {
      if (ID === "AIR") return "fas fa-democrat";
      if (ID === "ANN") return "fas fa-spider";
      if (ID === "ASC") return "fas fa-arrows-alt-v";
      if (ID === "BAD") return "fas fa-lock-open";
      if (ID === "CHE") return "fas fa-thermometer-three-quarters";
      if (ID === "ELE") return "fas fa-bolt";
      if (ID === "EV") return "fab fa-pagelines";
      if (ID === "HUM") return "fas fa-tint";
      if (ID === "INT") return "fas fa-phone-square";
      if (ID === "MAC") return "fas fa-drafting-compass";
      if (ID === "MEN") return "fas fa-tree";
      if (ID === "OCC") return "fas fa-low-vision";
      if (ID === "PLO") return "fas fa-faucet";
      if (ID === "PPK") return "fas fa-warehouse";
      if (ID === "SEC") return "fas fa-shield-alt";
      if (ID === "SER") return "fas fa-key";
      if (ID === "SOL") return "fas fa-shoe-prints";
      if (ID === "TOI") return "fas fa-home";
      if (ID === "TPI") return "fas fa-ruler-combined";
      if (ID === "TRA") return "fas fa-ruler-combined";
      if (ID === "TSE") return "fas fa-ruler-combined";
      if (ID === "TV") return "fas fa-tv";
      if (ID === "VEN") return "fas fa-fan";
      if (ID === "VEN") return "fab fa-windows";
      if (ID === "VPK") return "fas fa-car";
      if (ID === "VAN") return "fas fa-angry";
      if (ID === "TDV") return "fas fa-people-arrows";
      if (ID === "TR") return "fas fa-users-slash";
      if (ID === "P") return "fas fa-poop";
      if (ID === "VIT") return "fab fa-chromecast";
      return "fas fa-cog";
    },
    renderRelance(nb) {
      if (nb < 2) return "#131313";
      else return "#ffc107";
    },

    reloadConfigUser() {
      this.showGeolocated = this.userConfig?.geoloc??false;
      this.motRecherche = this.userConfig?.motRecherche??"";
      this.showAffected = this.userConfig?.showAffected??true;
      this.showEnCours = this.userConfig?.showEnCours??true;
      this.showEnAttente = this.userConfig?.showEnAttente??true;
      this.showClotures = this.userConfig?.showClotures??false;
      this.rangeDist = this.userConfig?.rangeDist??5;
      this.relanceToShow = this.userConfig?.relanceToShow??2;
    },
  },
  computed: {
    dateDebutIsBeforeNow() {
      //check if the year of dateDebut is before current year
      let dateDebut = new Date(this.dateDebut * 1000);
      let currentDate = new Date();
      return dateDebut.getFullYear() < currentDate.getFullYear();
    },
    dateDeb() {
      return new Date(this.dateDebut * 1000).toLocaleString('fr-FR', {month: 'long'}) + ' ' + new Date(this.dateDebut * 1000).getFullYear();
    },
    showOverlay() {
      // Permet d'activer le loader global (désactivé suite à la v1.7)
      // return (this.$store.getters['sollicitations/'].notClosedIsLoading())
      return false;
    },
    closedIsLoading() {
      return this.$store.getters['sollicitations/closedIsLoading']
    },
    notClosedIsLoading() {
      return this.$store.getters['sollicitations/notClosedIsLoading']
    },
    sollicitations() {
      return this.$store.getters['sollicitations/getSollicitationsOrderByDate'];
    },
    maxPage() {
      if (this.sollicitationsFiltred != null) {
        let max = this.sollicitationsFiltred.length / this.maxItemPerPage + 1;

        return max | 0;
      }
      return 1;
    },
    sollicitationsFiltred() {
      let res = null;

      if (this.sollicitations) {
        switch (this.source) {
          case "liste":
            if (this.showAffected && this.showAffectedToggle) {
              this.$store.dispatch('sollicitations/switchAffected')
              //this.$store.dispatch('sollicitations/'loadAffectedSollicitation(this.codePec), this.dateDebut) // Charge et positionne la liste des sollicitations actives à affectedSollicitations
              res = this.sollicitations.filter(
                  (sollicitation) =>
                      this.codePec &&
                      sollicitation.responsable == this.codePec &&
                      ((this.showEnAttente && ['A', 'N'].includes(sollicitation.etat)) ||
                          (this.showEnCours && sollicitation.etat == "O") ||
                          (this.showClotures && sollicitation.etat == "C"))
              );
            } else {
              this.$store.dispatch('sollicitations/switchCreated')
              //this.$store.dispatch('sollicitations/'loadCreatedSollicitation(this.codeTiers), this.codePec, this.dateDebut) // Charge et positionne la liste des sollicitations actives à createdSollicitations
              res = this.sollicitations.filter(
                  (sollicitation) =>
                      (sollicitation.reclamant == this.codeTiers || (this.codePec && sollicitation.pecsaisipar == this.codePec)) &&
                      ((this.showEnAttente && ['A', 'N'].includes(sollicitation.etat)) ||
                          (this.showEnCours && sollicitation.etat == "O") ||
                          (this.showClotures && sollicitation.etat == "C"))
              );
            }
            break;

          case "relance":
            this.$store.dispatch('sollicitations/switchAll')
            res = this.sollicitations.filter(
                (sollicitation) =>
                    ((this.showEnAttente && ['A', 'N'].includes(sollicitation.etat)) ||
                        (this.showEnCours && sollicitation.etat == "O") ||
                        (this.showClotures && sollicitation.etat == "C")) &&
                    sollicitation.relance >= this.relanceToShow
            );
            break;

          case "all":
            this.$store.dispatch('sollicitations/switchAll')
            res = this.sollicitations.filter(
                (sollicitation) =>
                    ((this.showEnAttente && ['A', 'N'].includes(sollicitation.etat)) ||
                        (this.showEnCours && sollicitation.etat == "O") ||
                        (this.showClotures && sollicitation.etat == "C"))
            );
            break;

          default:
            this.$store.dispatch('sollicitations/switchPatrimoine')
            //this.$store.dispatch('sollicitations/'loadSollicitationsPatrimoineFromAPI(this.dateDebut))
            res = this.sollicitations.filter(
                (sollicitation) =>
                    (this.showEnAttente && ['A', 'N'].includes(sollicitation.etat)) ||
                    (this.showEnCours && sollicitation.etat == "O") ||
                    (this.showClotures && sollicitation.etat == "C")
            );
        }
      }
      if (res) {
        let r = regexNormalize(this.motRecherche);
        // Si une recherche est effectuée depuis la barre de recherche
        if (r) {
          res = res.filter(sol =>
              sol.description && sol.description.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.type.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.nature.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.motif && sol.motif.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.libelleReclamant && sol.libelleReclamant.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.libelleModule && sol.libelleModule.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.logement && sol.logement.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.libelleProg.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.libelleAdresse && sol.libelleAdresse.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.telephone && sol.telephone.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.id.toLowerCase().replace(/\s/g, "").includes(r) ||
              sol.responsableLibelle && sol.responsableLibelle.toLowerCase().replace(/\s/g, "").includes(r)
          );
        }
        // Si le critère de géolocalisation est activé
        if (this.showGeolocated) {
          if (this.getGeolocalisation()) {
            res = res.filter((sol) => {
              if (sol.gps) {
                let longSol = sol.gps.split(",")[1];
                let latSol = sol.gps.split(",")[0];
                sol.dist = distance(
                    longSol,
                    latSol,
                    this.longitude,
                    this.latitude
                );
                return sol.dist <= this.rangeDist;
              } else return false;
            });
            res = lodash.orderBy(res, ["dist"], ["asc"]);
          }
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.currentPage = 1;

        return res;
      } else {
        return null;
      }
    },
    manageRelance() {
      return this.source == "relance";
    },
    page() {
      return this.sollicitationsFiltred != null
          ? this.sollicitationsFiltred.slice(
              (this.currentPage - 1) * this.maxItemPerPage,
              this.maxItemPerPage * this.currentPage
          )
          : {};
    },
    userConfig() {
      return this.$store.getters['user/getConfig'];
    },
    codePec() {
      return this.$store.getters['user/getCodePec'];
    },
    codeTiers() {
      return this.$store.getters['user/getCodeTiers'];
    },
    showAffectedToggle() {
      return this.$store.getters['user/canBeAffected'];
    },
    nbSollicitations() {
      if (this.sollicitationsFiltred) return this.sollicitationsFiltred.length;

      return 0;
    }
  },
  async mounted() {
    // this.source = this.$route.params.source
    this.reloadConfigUser();

    await this.loadData();
    
    this.minRange = process.env.VUE_APP_GEOLOC_MIN;
    this.maxRange = process.env.VUE_APP_GEOLOC_MAX;
    this.step = process.env.VUE_APP_GEOLOC_STEP;
  },
};
</script>

<style scoped>
.b-overlay-liste {
  min-height: 80vh;
}

/*Style générique de la liste*/
li {
  list-style: none;
}

li.list-group-item {
  padding: 2px 2px 10px 2px;
  min-height: 80px;
  /*  possibilité de remplacer par min-height si bug de responsive*/
}

li.list-group-item.flex {
  opacity: 0.8;
  cursor: pointer;
}

li.list-group-item.flex:nth-child(2n) {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.03);
}

li.flex {
  display: flex;
  justify-content: center;
}

li.flex div {
  /*border: dashed rgba(44, 62, 80, 0.3);*/
  padding: 5px;
}

li.flex div.sollicitation-img {
  justify-self: center;
  align-self: center;
  overflow: hidden;
  min-width: 60px;
  width: 60px;
}

li.flex div.sollicitation-infos {
  flex: auto;
  text-align: left;
  padding-left: 20px;
  overflow: hidden;
}

li.flex div.sollicitation-infos p {
  margin-bottom: 0;
}

li.flex div.sollicitation-etat {
  flex: 0.2;
  max-width: 20px;
}

/* fin style générique de la liste*/

span.etat-absolute-position {
  position: absolute;
  right: 2px;
  top: 12px;
  padding: 0%;
  box-shadow: 0px 3px 4px;
  border: solid 1px;

  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
}

pre {
  max-height: 300px;
  overflow: auto;
  border: dashed rgba(44, 62, 80, 0.3);
}

.enCours.active {
  background-color: var(--bs-success) !important;
}

.enCours {
  background-color: var(--bs-gray-500) !important;
  border-style: none;
}

.enAttente.active {
  background-color: var(--bs-warning) !important;
}

.enAttente {
  background-color: var(--bs-gray-500) !important;
  border-style: none;
}

.clotures.active {
  background-color: var(--bs-black) !important;
}

.clotures {
  background-color: var(--bs-gray-500) !important;
  border-style: none;
}

.aide li {
  list-style: inside !important;
}

input[type="range"] {
  height: 32px;
  -webkit-appearance: none;
  margin: 10px 0;
  width: 50%;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 8px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #495057;
}

input[type="range"]::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px #43425d;
  border: 1px solid #43425d;
  height: 25px;
  width: 35px;
  border-radius: 35px;
  background: #a4a128;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -9.5px;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  background: #ffffff;
}

input[type="range"]::-moz-range-track {
  width: 100%;
  height: 8px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #495057;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #495057;
}

input[type="range"]::-moz-range-thumb {
  box-shadow: 0px 0px 0px #43425d;
  border: 1px solid #43425d;
  height: 25px;
  width: 15px;
  border-radius: 5px;
  background: #a4a128;
  cursor: pointer;
}

input[type="range"]::-ms-track {
  width: 100%;
  height: 8px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}

input[type="range"]::-ms-fill-lower {
  background: #ffffff;
  border: 1px solid #495057;
  border-radius: 10px;
  box-shadow: 0px 0px 0px #495057;
}

input[type="range"]::-ms-fill-upper {
  background: #ffffff;
  border: 1px solid #495057;
  border-radius: 10px;
  box-shadow: 0px 0px 0px #495057;
}

input[type="range"]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 0px 0px 0px #43425d;
  border: 1px solid #43425d;
  height: 25px;
  width: 15px;
  border-radius: 5px;
  background: #a4a128;
  cursor: pointer;
}

input[type="range"]:focus::-ms-fill-lower {
  background: #ffffff;
}

input[type="range"]:focus::-ms-fill-upper {
  background: #ffffff;
}
</style>
